import { Injectable } from '@angular/core';
import { PublisherTag } from 'app/modules/main/models/publisher-tags-and-promotional-types';
import { SelectableData } from 'app/modules/main/components/data-selector/data-selector.models';
import { SelectableDataColumn } from 'app/modules/main/components/data-selector/data-selector.models';
import { SelectableDataColumnExtractor } from 'app/modules/main/components/data-selector/data-selector.models';
import { of } from 'rxjs';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PublisherTagColumnExtractor implements SelectableDataColumnExtractor<PublisherTag> {

  // select control column width is 13%
  //  -- all columns should add up to 100%
  readonly columns: SelectableDataColumn[] = [
    {
      headingLabel: $localize`:@@communication-centre.advertiser.publisher-tag-selector.column.tag.label:Tag`,
      headingStyle: { width: '87%' }, valueStyle: { width: '87%' }
    },
  ];

  getValue(
    index: number,
    selectablePublisherTag: SelectableData<PublisherTag>
  ): Observable<string> {

    const publisherTag = selectablePublisherTag.data;

    switch (index) {

      case 0:
        return of(publisherTag.name);

      default:
        return of('');
    }
  }

}
